<template>
  <div  :ref="elementRef">
    <slot v-if="fieldAccess === 'write' || noPermission"/>
    <fieldset v-if="fieldAccess === 'read'" disabled>
        <slot @click.stop.prevent></slot>

    </fieldset>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "AuthWrapper",
  props: {
    tab: {},
    noPermission:{type: Boolean, default: false},
    field: {},
    entity: {},
  },

  data() {
    return {
      fieldPermissions: [],
      entityPermission: "",
      fielddAccess: true,
      key: 0,
      elementRef : this.entity + "@" + this.tab + "@" + this.field
    }
  },
  computed: {
    ...mapGetters([
      'TABS_FIELDS', 'PERMISSIONS_WITH_FIELDS'
    ]),
    fieldAccess() {
      let element = this.$refs[this.elementRef];
      let access = "";
      let idx = this.PERMISSIONS_WITH_FIELDS.findIndex(x => {
        return x.entityPermission.entity === this.entity
      });
      if(idx === -1) return  true;
      let fieldPermissions = this.PERMISSIONS_WITH_FIELDS[idx].entityPermission.fieldPermissions;
      let entityPermission = this.PERMISSIONS_WITH_FIELDS[idx].entityPermission.serviceAccess;

      let per = fieldPermissions.find(y => {
        return y.field === this.field
      });
      if (!per) {
        access = entityPermission;
      } else {
        access = per.access;
      }
      if (access === "deny") {
        return "deny";
      }

      if (access === "read") {
        return "read"
      }
      return "write";
    },


  },
  created() {
    if ( this.tab)
      this.$store.dispatch("ADD_FIELD_TO_TAB", {tab: this.tab, field: this.field})
  }
  ,

  methods: {


  }
}
</script>